import { render, staticRenderFns } from "./PanelSummary.vue?vue&type=template&id=0155c864&scoped=true&"
import script from "./PanelSummary.vue?vue&type=script&lang=js&"
export * from "./PanelSummary.vue?vue&type=script&lang=js&"
import style0 from "./PanelSummary.vue?vue&type=style&index=0&id=0155c864&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0155c864",
  null
  
)

export default component.exports